import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { CancelCircleFillIcon } from '@chegg-ui/horizon-icons';
import { getThemeConfig, LeftAlignedTooltip, RemoveButton, TagContainer, TagRoot } from '../styles';
var truncationLength = 20;

var truncateTextAsNeeded = function truncateTextAsNeeded(textToTruncate, length, truncationType) {
  var truncatedString = textToTruncate;

  if (textToTruncate.length > length && truncationType !== 'none') {
    if (truncationType === 'end') {
      truncatedString = "".concat(truncatedString.slice(0, length - 3), "...");
    } else {
      truncatedString = "".concat(truncatedString.slice(0, 10), "...").concat(truncatedString.slice(-7));
    }
  }

  return truncatedString;
};

var Tag = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var dataTest = _ref['data-test'],
      active = _ref.active,
      children = _ref.children,
      helperText = _ref.helperText,
      onClick = _ref.onClick,
      onRemove = _ref.onRemove,
      removeText = _ref.removeText,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'lg' : _ref$size,
      tagColor = _ref.tagColor,
      theme = _ref.theme,
      _ref$truncationType = _ref.truncationType,
      truncationType = _ref$truncationType === void 0 ? 'end' : _ref$truncationType,
      _ref$passive = _ref.passive,
      passive = _ref$passive === void 0 ? false : _ref$passive,
      props = _objectWithoutProperties(_ref, ["data-test", "active", "children", "helperText", "onClick", "onRemove", "removeText", "size", "tagColor", "theme", "truncationType", "passive"]);

  var componentTheme = useComponentTheme({
    name: 'Tag',
    theme: getThemeConfig(theme)
  });
  var enableTooltip = helperText || children.length > truncationLength;
  var containerTag = onClick ? 'button' : 'div';
  var tagStatus = passive ? '' : active ? 'active' : 'inactive';
  var truncatedString = truncateTextAsNeeded(children, truncationLength, truncationType);
  var ariaLabel = "".concat(truncatedString, " ").concat(tagStatus);
  var tagContainer = /*#__PURE__*/React.createElement(TagContainer, {
    "aria-label": ariaLabel,
    active: active,
    passive: passive,
    as: containerTag,
    customTheme: componentTheme,
    "data-test": "".concat(dataTest, "-text"),
    isRemovable: !!onRemove,
    onClick: onClick,
    ref: ref,
    size: size,
    tagColor: tagColor
  }, truncatedString);
  return /*#__PURE__*/React.createElement(TagRoot, _extends({}, props, {
    "data-test": dataTest
  }), enableTooltip ? /*#__PURE__*/React.createElement(LeftAlignedTooltip, {
    position: "bottomRight",
    targetElement: tagContainer
  }, /*#__PURE__*/React.createElement(React.Fragment, null, helperText || children)) : tagContainer, onRemove ? /*#__PURE__*/React.createElement(RemoveButton, {
    active: active,
    passive: passive,
    customTheme: componentTheme,
    "data-test": "".concat(dataTest, "-remove-button"),
    onClick: onRemove,
    screenReaderOnlyText: removeText || "remove ".concat(children),
    size: componentTheme[size].removeButtonSize
  }, /*#__PURE__*/React.createElement(CancelCircleFillIcon, null)) : undefined);
});
Tag.displayName = 'Tag';
export default Tag;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/tag/dist/esm/variants/Tag.js
// module id = 851
// module chunks = 11